import { IUser, User } from '../user'

export class SearchItem {
  public type: string
  public property: string
  public value: string
  public relProperty: string | null
  public relValue: string | null
  public relSort: string | null
  public isNot: boolean | null

  constructor (type: string, property: string, value: string, relProperty: string|null, relValue: string|null, relSort: string|null, isNot: boolean=false) {
  this.type=type
  this.property=property
  this.value=value
  this.relProperty=relProperty
  this.relValue=relValue
  this.relSort=relSort
  this.isNot = isNot
  }
}

export class SearchQuery {
  public sort: string[] | null = null
  public descending: boolean = false
  public pageSize: number | null = null
  public pageNum: number | null = null
  public searchItems: SearchItem[] = []
}

export class SearchForm {
  public createdByFollowing: boolean = false
  public createdByUser: boolean = false
  public createdByMe: boolean = false
  public searchUser: IUser = new User()
  public tag: string = ''
  public tags: string[] = []
}

export class StatementSearchForm extends SearchForm{
  public jybedByFollowing: boolean = false
  public jybedByUser: boolean = false
  public jybedByMe: boolean = false
  public consideredByMe: boolean = false
  public ignoredByMe: boolean = false
  public notReactedByMe: boolean = false
}

export class ConvoSearchForm extends SearchForm{
  public likedByFollowing: boolean = false
  public likedByUser: boolean = false
  public likedByMe: boolean = false
  public followedByMe: boolean = false
}

export class PostSearchForm extends SearchForm{
  public likedByMe: boolean = false
}
